import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuthStore } from "@/lib/auth";

export function ProtectedRoute() {
  const isAuth = useAuthStore((s) => s.isAuthenticated());
  const location = useLocation();

  if (!isAuth) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
